function iOSSafari() {
    var isSafari = /safari/ig.test(window.navigator.userAgent) && /webkit/ig.test(window.navigator.userAgent) && !(/Google Inc/ig.test(navigator.vendor))
    return isSafari
}
export function queryMicAccess(allowedCb, notAllowedCb){
        if(iOSSafari()){
            notAllowedCb()
            return
        }

        try {
            if (!navigator.permissions || typeof navigator.permissions.query !== "function") {
                notAllowedCb()
                return
            }

            navigator.permissions.query({ name: "microphone" })
                .then(function (permissionStatus) {
                    if (permissionStatus && permissionStatus.state === "granted") {
                        allowedCb()
                    } else {
                        notAllowedCb()
                    }
                })
                .catch(function () {
                    notAllowedCb()
                })
        } catch (e) {
            notAllowedCb()
        }
    }